var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ivv-content"},[_c('div',{staticClass:"ivv-box"},[_c('van-row',{staticClass:"team-list"},_vm._l((_vm.dataList),function(item,index){return _c('van-col',{key:index,attrs:{"span":"8"}},[_c('div',[_vm._v(_vm._s(item.groupName))]),_c('div',[_vm._v("业绩："+_vm._s(item.perf))])])}),1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }